//------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by d2-i18n-generate.
//
// Changes to this file may cause incorrect behavior and will be lost if
// the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import i18n from '@dhis2/d2-i18n';
import moment from 'moment';
import 'moment/locale/ar';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/lo';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/sv';
import 'moment/locale/uk';
import 'moment/locale/ur';
import 'moment/locale/vi';

import arTranslations from './ar/translations.json';
import daTranslations from './da/translations.json';
import enTranslations from './en/translations.json';
import esTranslations from './es/translations.json';
import frTranslations from './fr/translations.json';
import idTranslations from './id/translations.json';
import kmTranslations from './km/translations.json';
import loTranslations from './lo/translations.json';
import myTranslations from './my/translations.json';
import prsTranslations from './prs/translations.json';
import psTranslations from './ps/translations.json';
import ptTranslations from './pt/translations.json';
import ruTranslations from './ru/translations.json';
import svTranslations from './sv/translations.json';
import tetTranslations from './tet/translations.json';
import ukTranslations from './uk/translations.json';
import urTranslations from './ur/translations.json';
import viTranslations from './vi/translations.json';

const namespace = 'dashboards-app';
moment.locale('en');

i18n.addResources('ar', namespace, arTranslations);
i18n.addResources('da', namespace, daTranslations);
i18n.addResources('en', namespace, enTranslations);
i18n.addResources('es', namespace, esTranslations);
i18n.addResources('fr', namespace, frTranslations);
i18n.addResources('id', namespace, idTranslations);
i18n.addResources('km', namespace, kmTranslations);
i18n.addResources('lo', namespace, loTranslations);
i18n.addResources('my', namespace, myTranslations);
i18n.addResources('prs', namespace, prsTranslations);
i18n.addResources('ps', namespace, psTranslations);
i18n.addResources('pt', namespace, ptTranslations);
i18n.addResources('ru', namespace, ruTranslations);
i18n.addResources('sv', namespace, svTranslations);
i18n.addResources('tet', namespace, tetTranslations);
i18n.addResources('uk', namespace, ukTranslations);
i18n.addResources('ur', namespace, urTranslations);
i18n.addResources('vi', namespace, viTranslations);

i18n.setDefaultNamespace(namespace);
i18n.changeLanguage('en');

export default i18n;



// WEBPACK FOOTER //
// ./src/locales/index.js